module.exports = __webpack_public_path__ + "static/nelson_moses-6d2b26285e024071e16f0159ec46cfcd.pdf";